import { Configuration } from './types';

const config: Record<string, Configuration> = {
  sandbox: {
    application: 'asset-transfer-ui',
    basePath: '/usis/transactions/transfer',
    port: 3000,
    sslPort: 3443,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
      'X-Frame-Options': 'SAMEORIGIN',
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
    },
    url: window?.location
      ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
      : 'http://localhost:3000',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    debug: {
      enableReduxDevTools: true,
    },
  },
  dev: {
    application: 'asset-transfer-ui',
    basePath: '/usis/transactions/transfer',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
      internal: 'https://api.dev.awstrp.net',
    },
    url: 'https://wwwdev.troweprice.com',
    serviceHost: 'https://api.dev.awstrp.net/',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    debug: {
      enableReduxDevTools: true,
    },
    allowedAuthentication: 'both',
    localhostAuthType: 'external',
    baseEnvHost: 'https://api.dev.awstrp.net/',
    customerWebViewEnabled: true,
    authorizePath: 'nitro_oauth-common-callback/login',
    sandboxAuthCookieEnabled: false,
  },
  stage: {
    application: 'asset-transfer-ui',
    basePath: '/usis/transactions/transfer',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    vault: 'https://vault.stage.troweprice.io:8200',
    api: {
      host: 'https://api.confidence.troweprice.com',
      internal: 'https://api.stage.awstrp.net',
    },
    url: 'https://wwwstage.troweprice.com',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    debug: {
      enableReduxDevTools: true,
    },
  },
  prod: {
    application: 'asset-transfer-ui',
    basePath: '/usis/transactions/transfer',
    port: 3000,
    api: {
      host: 'https://api.public.troweprice.com',
      internal: 'https://api.prod.awstrp.net',
    },
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    url: 'https://www.troweprice.com',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    debug: {
      enableReduxDevTools: false,
    },
    vault: 'https://vault.troweprice.io:8200',
    env: 'prod',
  },
};

let env: Partial<Configuration> = {};
// secondary flag doesn't actually pass since __CONFIG__ is evaluated during build
if (
  typeof window.location !== 'undefined' &&
  !window.location.host.includes('localhost')
) {
  if (window.location.host.includes('dev')) {
    env = config['dev'];
  } else if (window.location.host.includes('stage')) {
    env = config['stage'];
  } else {
    env = config['prod'];
  }
  if (
    window.location.host.includes('awstrp') &&
    !(env.url as string)?.includes('awstrp')
  ) {
    env.url = `https://${window.location.host}`;
  }
} else {
  env = config['dev'];
}

export default env;
